import { cacheTypes, getMethodByCallBack, postMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions";
/**
 * 
 * @param {object}  data
 * @param {function} onAddEdit
 */
export function addEditStatus(data, onAddEdit) {
    postMethodByCallBack("api/BoMAPI/AddEditStatus", data, onAddEdit, "AddEditStatus");
}
/**
 * 
 * @param {List} orderList 
 * @param {function} onReorder 
 */
export function reorderStatusList(orderList, onReorder) {
    postMethodByCallBack("api/BoMAPI/ReorderStatusList", orderList, onReorder, "ReorderStatusList");
}
/**
 * 
 * @param {int} id 
 * @param {function} onDelete 
 */
export function deleteStatus(id, onDelete) {
    getMethodByCallBack(`api/BoMAPI/DeleteStatus?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteStatus");
}
/**
 * 
 * @param {function} onGet 
 */
export function getStatusList(onGet) {
    getMethodByCallBack("api/BoMAPI/GetStatusList", cacheTypes.NoCache, onGet, "GetStatusList");
}
/**
 * 
 * @param {int} id 
 * @param {function} onGet 
 */
export function getBoM(id, onGet) {
    getMethodByCallBack(`api/BoMAPI/GetBoM?id=${id}`, cacheTypes.NoCache, onGet, "GetBoM");
}
/**
 * 
 * @param {object} data 
 * @param {function} onAddEdit 
 */
export function addEditBoM(data, onAddEdit) {
    postMethodByCallBack("api/BoMAPI/AddEditBoM", data, onAddEdit, "AddEditBoM");
}
/**
 * @param {int} bomType 
 * @param {Function} onGet 
 */
export function getNextNumber(bomType, onGet) {
    getMethodByCallBack(`api/BoMAPI/GetNextNumber?bomType=${bomType}`, cacheTypes.NoCache, onGet, "GetNextNumber");
}
/**
 * 
 * @param {object} data 
 * @param {function} onChange 
 */
export function changeBoMStatus(data, onChange) {
    postMethodByCallBack("api/BoMAPI/ChangeBoMStatus", data, onChange, "ChangeBoMStatus");
}
/**
 * 
 * @param {int} id 
 * @param {function} onDelete 
 */
export function deleteBoM(id, onDelete) {
    getMethodByCallBack(`api/BoMAPI/DeleteBoM?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteBoM");
}
/**
 * 
 * @param {object} data
 */
export function searchBoM(data) {
    return dispatch => {
        dispatch({
            type: "BoM_SEARCH_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/BoMAPI/SearchBoM", data, "SEARCH_BOM", "جستجوی فرم تولید"));
    }
}
/**
 * 
 * @param {object} data 
 * @param {onGetData} onGetData 
 */
export function searchBoMForSelect(data, onGetData) {
    postMethodByCallBack("api/BoMAPI/SearchBoM", data, onGetData, "SearchBoM");
}
/**
 * 
 * @param {object} data 
 * @param {function} onAddEdit 
 */
export function addEditRequest(data, onAddEdit) {
    postMethodByCallBack("api/BoMAPI/AddEditRequest", data, onAddEdit, "AddEditRequest");
}
/**
 * 
 * @param {int} id 
 * @param {function} onDelete 
 */
export function deleteRequest(id, onDelete) {
    getMethodByCallBack(`api/BoMAPI/DeleteRequest?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteRequest");
}
export function searchRequest(data) {
    return dispatch => {
        dispatch(postMethodByDispatcher("api/BoMAPI/SearchRequest", data, "SEARCH_BOM_REQ", "جستجوی درخواست تولید"));
    }
}
